import { ILocation } from "../../../common/types";
import {
  UPDATE_LOCATION,
  DELETE_LOCATION,
  FETCH_LOCATIONS,
  LISTEN_TO_SELECTED_LOCATION,
} from "./locationConstants";

export function listenToLocations(locations: ILocation[]) {
  return {
    type: FETCH_LOCATIONS,
    payload: locations,
  };
}

export function listenToSelectedLocation(location: ILocation) {
  return {
    type: LISTEN_TO_SELECTED_LOCATION,
    payload: location,
  };
}

export function updateLocation(location: ILocation) {
  return {
    type: UPDATE_LOCATION,
    payload: location,
  };
}

export function deleteLocation(locationId: string) {
  return {
    type: DELETE_LOCATION,
    payload: locationId,
  };
}
